export default {
  uploadUrl: 'https://up-z2.qiniup.com/',
  fetchUrl: 'http://cdn.whhda.xyz/'
}
